(function(ring) {


  publishingApp.directive('ring', function() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        percent: '@',
        animDelay: '@',
        label: '@'
      },
      template:
        '<div class="ring">' +
        '    <div class="content" ng-transclude></div>' +
        '    <svg viewBox="0 0 200 200">' +
        '        <circle class="back-ring" cx="100" cy="100" r="90" />' +
        '        <circle class="outer" cx="100" cy="100" r="90" transform="rotate(-90, 100, 100)" stroke-dashoffset="{{offset}}" />' +
        '    </svg>' +
        '    <div class="label">{{label}}</div>'+
        '</div> ',
      controller: ['$scope', '$timeout', '$element', function($scope, $timeout, $element) {
        $scope.offset = 565.49;
        var $window = $(window);
        $window.bind('scroll', function() {
          var window_height = $window.height();
          var window_top_position = $window.scrollTop();
          var window_bottom_position = (window_top_position + window_height);

          var element_height = $element.outerHeight();
          var element_top_position = $element.offset().top;
          var element_bottom_position = (element_top_position + element_height);

          //check to see if this current container is within viewport
          if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $timeout(
              function() {
                $scope.offset = 565.49 * (100 - $scope.percent) / 100;
                $scope.$apply();
              },
              $scope.animDelay
            );
          } else {
            //$scope.offset = 565.49;
            //$scope.$apply();
          }
        });

      }]
    };
  });

}('ring'));
